import { z } from "zod";

export const messageMode = z.enum(["chat", "agent"]);
export type MessageMode = z.infer<typeof messageMode>;
